export const standardTags = ['Crane/Lift', 'Container', 'Drying', 'City', 'Construction', 'Lighting', 'Other Total'];
